export const isWeatherChanged = (sheet, updates) => {
  if (updates?.temperature && sheet.weather?.temperature) {
    if (updates.temperature?.length !== sheet.weather.temperature?.length) return true;
    for (let i = 0; i < updates.temperature.length; ++i) {
      if (updates.temperature[i] !== sheet.weather.temperature[i]) return true;
    }
  } else return true;

  if (updates.humidity !== sheet.weather.humidity) return true;

  if (updates.notes !== sheet.weather.notes) return true;
  
  return false;
}

export const isTimeChanged = (sheet, updates) => {
  if (sheet.startTimeDate && updates.startTimeDate && new Date(sheet.startTimeDate).getTime() !== new Date(updates.startTimeDate)) return true;
  if (sheet.startTime.hour !== updates.startTime.hour || sheet.startTime.minute !== updates.startTime.minute) return true;
  if (sheet.timeOfDay !== updates.timeOfDay) return true;
  if ((sheet.hours?.start && updates.hours?.start && (
      new Date(sheet.hours?.start)?.getTime() !== new Date(updates.hours?.start)?.getTime() ||
      new Date(sheet.hours?.end)?.getTime() !== new Date(updates.hours?.end)?.getTime()
     )) ||
      !!sheet.hours?.start !== !!updates.hours?.start ||
      sheet.hours.travelTimeTo?.hours !== updates.hours?.travelTimeTo?.hours ||
      sheet.hours.travelTimeTo?.minutes !== updates.hours?.travelTimeTo?.minutes ||
      sheet.hours.travelTimeFrom?.hours !== updates.hours?.travelTimeFrom?.hours ||
      sheet.hours.travelTimeFrom?.minutes !== updates.hours?.travelTimeFrom?.minutes
  ) return true;
  if (sheet.travelTimeOnly !== updates.travelTimeOnly) return true;
  if (
    sheet.rainPay?.hours !== updates.rainPay?.hours ||
    sheet.rainPay?.minutes !== updates.rainPay?.minutes ||
    sheet.rainPay?.description !== updates.rainPay?.description
  ) return true;
  if (sheet.isRainPayEnabled !== updates.isRainPayEnabled) return true;

  return false;
}

export const isNotesChanged = (sheet, updates) => {
  if (sheet.notes !== updates.notes || sheet.schedulerNotes !== updates.schedulerNotes) return true;

  return false;
}

export const isGeneralInfoChanged = (sheet, updates) => {
  // If contractor was changed then project have to be changed, so checking contractor is redundant
  if (sheet.project._id !== updates.projectId && sheet.project.oldProjectId !== updates.projectId) return true;

  if (sheet.forceAccount !== updates.forceAccount) return true;
  if (new Date(sheet.createdAt)?.getTime() !== new Date(updates.createdAt)?.getTime()) return true;
  if (sheet.grid?.date !== updates.gridDate) return true;
  if ((sheet.primaryContact?._id !== updates.primaryContact?._id) || !!sheet.primaryContact !== !!updates.primaryContact) return true;
  if (updates.addLocations?.length) return true;
  if (updates.addContacts?.length) return true;

  if (sheet.locations?.length !== updates.locations?.length) return true;
  if (sheet.rallyPoints?.length !== updates.rallyPoints?.length) return true;
  if (sheet.alternateContacts?.length !== updates.alternateContacts?.length) return true;
  if (sheet.locations?.some(location => !updates.locations?.includes(location))) return true;
  if (sheet.rallyPoints?.some(rallyPoint => !updates.rallyPoints?.includes(rallyPoint))) return true;
  if (sheet.alternateContacts?.some(contact => !updates.alternateContacts?.includes(contact?._id))) return true;

  return false;
}

export const isWorkersChanged = (sheet, workers) => {
  if (sheet.workers?.length !== workers?.length) return true;
  for (let i = 0; i < sheet.workers?.length; ++i) {
    const sWorker = sheet.workers[i];
    const uWorker = workers[i];
    if (sWorker?._id !== uWorker?._id) return true;
    if (!!sWorker?.foreman !== !!uWorker?.foreman) return true;
    if (sWorker?.startTime?.hour !== uWorker?.startTime?.hour || sWorker?.startTime?.minute !== uWorker?.startTime?.minute) return true;
    if ((sWorker?.laborClassificationId || null) !== (uWorker?.laborClassificationId || null)) return true;
    if (sWorker?.hours?.length !== uWorker?.hours?.length) return true;
    if (sWorker?.hours?.length && uWorker?.hours?.length) {
      for (let j = 0; j < sWorker.hours.length; j++) {
        const sHours = sWorker.hours[j];
        const uHours = uWorker.hours[j];
        if (
          sHours?.start && uHours?.start && new Date(sHours.start).getTime() !== new Date(uHours.start).getTime() ||
          sHours?.end && uHours?.end && new Date(sHours.end).getTime() !== new Date(uHours.end).getTime()
        ) return true;

        if (
          sHours?.travelTimeTo?.hours && uHours?.travelTimeTo?.hours &&
          (
            sHours?.travelTimeTo?.hours !== uHours?.travelTimeTo?.hours ||
            sHours?.travelTimeTo?.minutes !== uHours?.travelTimeTo?.minutes
          )
        ) return true;
        if (
          sHours?.travelTimeFrom?.hours && uHours?.travelTimeFrom?.hours &&
          (
            sHours?.travelTimeFrom?.hours !== uHours?.travelTimeFrom?.hours ||
            sHours?.travelTimeFrom?.minutes !== uHours?.travelTimeFrom?.minutes
          )
        ) return true;
        if ((sHours?.laborClassificationId || null) !== (uHours?.laborClassificationId || null)) return true;
        if (!!sHours?.isWlHours !== !!uHours?.isWlHours || !!sHours?.isWlTravelTime !== !!uHours?.isWlTravelTime) return true;
      }
    }
  }

  return false;
}

export const isEquipmentChanged = (sheet, equipment) => {
  if (sheet.equipment?.length !== equipment?.length) return true;

  for (let i = 0; i < sheet.equipment?.length; ++i) {
    const sEquip = sheet.equipment[i];
    const uEquip = equipment[i];
    if (sEquip?._id !== uEquip?._id) return true;

    if (sEquip?.hours?.length !== uEquip?.hours?.length) return true;
    if (sEquip?.hours?.length && uEquip?.hours?.length) {
      for (let j = 0; j < sEquip.hours.length; j++) {
        const sHours = sEquip.hours[j];
        const uHours = uEquip.hours[j];
        if (
          (sHours?.start && uHours?.start && new Date(sHours.start).getTime() !== new Date(uHours.start).getTime()) ||
          (sHours?.end && uHours?.end && new Date(sHours.end).getTime() !== new Date(uHours.end).getTime())
        ) return true;

        if (
          sHours?.travelTimeTo?.hours && uHours?.travelTimeTo?.hours &&
          (
            sHours?.travelTimeTo?.hours !== uHours?.travelTimeTo?.hours ||
            sHours?.travelTimeTo?.minutes !== uHours?.travelTimeTo?.minutes
          )
        ) return true;
        if (
          sHours?.travelTimeFrom?.hours && uHours?.travelTimeFrom?.hours &&
          (
            sHours?.travelTimeFrom?.hours !== uHours?.travelTimeFrom?.hours ||
            sHours?.travelTimeFrom?.minutes !== uHours?.travelTimeFrom?.minutes
          )
        ) return true;
      }
    }
  }

  return false;
}